import React, { useMemo, useState } from 'react';
import { message } from 'antd';
import { useQuery, useMutation, useApolloClient } from '@apollo/client';
import HeaderView from './components/header';
import EmptyView from './components/empty-view';
import ListView from './components/list';
import ModalView from './components/modal';
import { ADD } from './constant';
import { useCurrentRoles } from '~components/switch-role/useSwitchRole';

import { ADD_PAYOUT_PLAN, QUERY_PAYOUT_PLAN_LIST, UPDATE_PAYOUT_PLAN } from './queries';

const PayoutPlan = () => {
  const client = useApolloClient();
  const { authRole } = useCurrentRoles();
  const [visible, setVisible] = useState(false);
  const [modalType, setModalType] = useState(ADD);
  const [selectedPayoutPlanItem, setSelectedPayoutPlanItem] = useState({});

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showQuickJumper: true,
    showSizeChanger: true,
    pageSizeOptions: ['10', '20', '30', '40'],
  });
  //添加payout plan
  const [mutationAddPayoutPlan] = useMutation(ADD_PAYOUT_PLAN, {
    onError: e => {
      message.error(e && e.toString && e.toString(), 10);
    },
  });

  // 查询列表数据
  const {
    loading: listLoading,
    data: payoutPlanListResponse,
    refetch: refetchPayoutList,
  } = useQuery(QUERY_PAYOUT_PLAN_LIST, {
    variables: {
      pageNumber: pagination.current,
      pageSize: pagination.pageSize,
    },
    onCompleted() {
      const totalCount = payoutPlanListResponse?.listPartnerPayoutPlans?.totalCount || 0;
      setPagination({
        ...pagination,
        total: totalCount,
      });
    },
    fetchPolicy: 'no-cache',
    onError: e => {
      message.error(e?.toString(), 10);
    },
  });

  const queryDefault = async variables =>
    await client.query({
      query: QUERY_PAYOUT_PLAN_LIST,
      fetchPolicy: 'no-cache',
      variables,
    });

  //更新payout plan
  const [mutationUpdatePayoutPlan] = useMutation(UPDATE_PAYOUT_PLAN, {
    onError: e => {
      message.error(e && e.toString && e.toString(), 10);
    },
  });

  const payoutPlanList = useMemo(() => {
    const listPartnerPayoutPlans = payoutPlanListResponse?.listPartnerPayoutPlans;
    const edges = listPartnerPayoutPlans?.edges?.map(item => item.node);
    return edges || [];
  }, [payoutPlanListResponse]);

  function setVisibleFn(visible, type) {
    setVisible(visible);
    setModalType(type || ADD);
  }

  function onClose() {
    setVisible(false);
  }

  const isShowAddBtn = !!payoutPlanList.length;
  return (
    <div className="payout-plan-container">
      <HeaderView shoAddBtn={isShowAddBtn} setVisibleFn={setVisibleFn} role={authRole} />
      {(payoutPlanList.length || listLoading) && (
        <div className="body">
          <ListView
            data={payoutPlanList}
            loading={listLoading}
            setVisibleFn={setVisibleFn}
            pagination={pagination}
            setPagination={setPagination}
            setSelectedPayoutPlanItem={setSelectedPayoutPlanItem}
            role={authRole}
          />
        </div>
      )}

      {!payoutPlanList.length && !listLoading && (
        <EmptyView setVisibleFn={setVisibleFn} role={authRole} />
      )}

      {visible && (
        <ModalView
          refetchPayoutList={refetchPayoutList}
          queryDefault={queryDefault}
          onClose={onClose}
          modalType={modalType}
          handAddPayoutPlan={mutationAddPayoutPlan}
          selectedPayoutPlanItem={selectedPayoutPlanItem}
          handUpdatePayoutPlan={mutationUpdatePayoutPlan}
        />
      )}
    </div>
  );
};

export default PayoutPlan;
